import { render, staticRenderFns } from "./NewCurrencyField.vue?vue&type=template&id=7b751578&"
import script from "./NewCurrencyField.vue?vue&type=script&lang=ts&"
export * from "./NewCurrencyField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports